import {SubscriptionBase} from "@core/base/subscription-base";
import {ISubscription} from "@core/base/subscription-base.types";
import { Observable } from "rxjs";

export class WebSubscription implements SubscriptionBase {

    constructor() {}

    public subscription!: ISubscription;

    public fetchSubscribeTrial(sessionID: string): Promise<void> {
        throw new Error('Method not Implemented')
    }

    public fetchSubscription(sessionID: string): Promise<ISubscription> {
        throw new Error('Method not Implemented')
    }

    public getSubscription(): ISubscription {
        throw new Error('Method not Implemented')
    }

    public openSubscriptionDocs(): void {
        throw new Error('Method not Implemented')
    }

    $getSubscription(): Observable<ISubscription> {
        throw new Error('Method not implemented')
    }
}
